import { motion } from 'framer-motion';
import { VIEWS } from './data';
// HOUSE VIEW — long-form research archive, broadsheet styling.
export default function HouseView() {
  return (
    <div className="bg-[#EFEAE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-2 border-[#1B1A18]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-4">— Section III · House View & Research</p>
        <h1 className="font-serif text-5xl lg:text-8xl leading-[0.92] tracking-[-0.02em] max-w-5xl">What we <span className="italic text-[#142437]">actually think</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#1B1A18]/65 mt-6 max-w-2xl">A small team of fifteen, mostly former practitioners, writes our research. Public dispatches below; client-only notes are mailed in print.</p>
      </section>

      {/* Featured view — full broadsheet article */}
      <article className="max-w-[1100px] mx-auto px-8 lg:px-14 py-16">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-4">— Lead dispatch · {VIEWS[0].d}</p>
        <h2 className="font-serif text-4xl lg:text-6xl leading-[1.05] tracking-tight mb-6">{VIEWS[0].t}</h2>
        <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#1B1A18]/55 mb-10">By {VIEWS[0].auth} &middot; {VIEWS[0].read} read</p>
        <div className="grid md:grid-cols-2 gap-10 font-serif text-lg text-[#1B1A18]/85 leading-[1.7] columns-1 md:columns-1">
          <p className="first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:leading-[0.85] first-letter:text-[#142437]">The market is pricing three rate cuts in 2026. We do not believe it. The disinflationary glide-path that consensus expects rests on three premises &mdash; a labour market that softens further, services CPI that follows goods, and an oil floor that holds.</p>
          <p>We are not yet convinced of any of the three. Wage settlements in our own underwriting book have hardened, not eased, in the past two quarters. We have positioned client portfolios accordingly: short duration, overweight private credit, neutral on equities with a quality tilt.</p>
        </div>
        <blockquote className="border-l-4 border-[#142437] pl-6 my-12 max-w-2xl">
          <p className="font-serif italic text-2xl lg:text-3xl leading-[1.3] text-[#1B1A18]">&ldquo;The cuts will come. They will not arrive on the schedule the curve currently implies. We are positioned for delay, not for cancellation.&rdquo;</p>
        </blockquote>
      </article>

      {/* Archive table */}
      <section className="border-y border-[#1B1A18]/15 bg-[#E5DDC9]">
        <div className="max-w-[1300px] mx-auto px-8 lg:px-14 py-16">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-8">— Recent dispatches · public</p>
          <table className="w-full font-serif">
            <tbody>
              {VIEWS.map(v => (
                <tr key={v.t} className="border-b border-[#1B1A18]/15 hover:bg-[#EFEAE0] cursor-pointer">
                  <td className="py-6 pr-4 align-top w-32 font-mono text-[10px] tracking-[0.25em] uppercase text-[#142437]">{v.d}</td>
                  <td className="py-6 pr-4">
                    <p className="text-xl lg:text-2xl leading-tight">{v.t}</p>
                    <p className="font-serif italic text-sm text-[#1B1A18]/55 mt-1">{v.auth}</p>
                  </td>
                  <td className="py-6 align-top text-right font-mono text-[10px] tracking-[0.25em] uppercase text-[#1B1A18]/45 whitespace-nowrap">{v.read} →</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
